export function getOffset(channel, markDef) {
    const offsetChannel = (channel + 'Offset'); // Need to cast as the type can't be inferred automatically
    // TODO: in the future read from encoding channel too
    const markDefOffsetValue = markDef[offsetChannel];
    if (markDefOffsetValue) {
        return markDefOffsetValue;
    }
    return undefined;
}
//# sourceMappingURL=offset.js.map